<template>
  <v-dialog v-if="item.image" class="elevation-0" lazy width="50%">
    <template #activator="{ on }">
      <v-img
        v-on="on"
        class="small-image"
        contain
        max-height="50"
        max-width="50"
        :src="item.image"
      />
    </template>
    <v-img contain max-height="75vh" :src="item.image" />
  </v-dialog>
</template>

<script>
export default {
  props: {
    item: {
      type: Object,
      required: true
    }
  }
};
</script>

<style scoped>
.small-image {
  margin-bottom: -19px;
  cursor: pointer;
}
</style>